var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_321_245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.65213 4.28271V11.2393",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58539 17.5002C3.28058 16.4323 4.23138 15.5549 5.35154 14.9475C6.4717 14.3401 7.72577 14.022 9.00001 14.022C10.2742 14.022 11.5283 14.3401 12.6485 14.9475C13.7686 15.5548 14.7194 16.4323 15.4146 17.5001",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3478 4.28262L8.99996 7.06524L0.6521 4.28262L8.99996 1.5L17.3478 4.28262Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5945 5.86719C13.2317 6.56437 13.6524 7.43179 13.8053 8.36381C13.9582 9.29583 13.8368 10.2522 13.4559 11.1165C13.0749 11.9807 12.4509 12.7155 11.6597 13.2314C10.8686 13.7473 9.94447 14.0219 8.99999 14.0219C8.05551 14.0219 7.13141 13.7473 6.34025 13.2314C5.5491 12.7155 4.92504 11.9807 4.54408 11.1165C4.16313 10.2522 4.04173 9.29583 4.19467 8.36381C4.34761 7.43179 4.76829 6.56437 5.40546 5.86719",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.65213 4.28271V11.2393",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.58539 17.5002C3.28058 16.4323 4.23138 15.5549 5.35154 14.9475C6.4717 14.3401 7.72577 14.022 9.00001 14.022C10.2742 14.022 11.5283 14.3401 12.6485 14.9475C13.7686 15.5548 14.7194 16.4323 15.4146 17.5001",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3478 4.28262L8.99996 7.06524L0.6521 4.28262L8.99996 1.5L17.3478 4.28262Z",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5945 5.86719C13.2317 6.56437 13.6524 7.43179 13.8053 8.36381C13.9582 9.29583 13.8368 10.2522 13.4559 11.1165C13.0749 11.9807 12.4509 12.7155 11.6597 13.2314C10.8686 13.7473 9.94447 14.0219 8.99999 14.0219C8.05551 14.0219 7.13141 13.7473 6.34025 13.2314C5.5491 12.7155 4.92504 11.9807 4.54408 11.1165C4.16313 10.2522 4.04173 9.29583 4.19467 8.36381C4.34761 7.43179 4.76829 6.56437 5.40546 5.86719",
    stroke: "#757575",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_321_245"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentDetails);
export default __webpack_public_path__ + "static/media/studentDetails.4df6290cc1c261d9ca3c91e921ac5e99.svg";
export { ForwardRef as ReactComponent };